import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiContracts } from 'modules/api';
import { PagingParams } from 'modules/types/PagingParams';
import { ContractGroup } from '../components/helper';

export const fetchContracts = createAsyncThunk(
  'contracts/fetchContracts',
  async (
    params: PagingParams & { contractGroup: ContractGroup },
    { rejectWithValue },
  ) => {
    try {
      let response;

      if (params.contractGroup === ContractGroup.ACTIVE) {
        response = await ApiContracts.getActiveContracts(params);
      } else if (params.contractGroup === ContractGroup.INACTIVE) {
        response = await ApiContracts.getInactiveContracts(params);
      } else {
        response = await ApiContracts.getAllContracts(params);
      }

      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
